import { Component, Input } from '@angular/core';
import { Address, AddressPart } from '@planone/shared/util-interfaces';

@Component({
  selector: 'planone-address',
  templateUrl: './address.component.html',
})
export class AddressComponent {
  private addressParts: { [key: string]: string } = {};

  @Input() format: AddressPart[] = ['city'];
  @Input() set address(address: Address) {
    const { city, country, house_number, street, zip_code } = address;
    if (city) this.addressParts['city'] = city;
    if (country) this.addressParts['country'] = country;
    if (house_number) this.addressParts['house_number'] = house_number;
    if (street) this.addressParts['street'] = street;
    if (zip_code) this.addressParts['zip_code'] = zip_code;
    this.hasAddress = true;
  }

  public hasAddress = false;

  get parts() {
    return this.format
      .map((key) => this.addressParts[key])
      .filter(Boolean)
      .reduce((collected, next) => collected + ', ' + next);
  }
}
